import { render, staticRenderFns } from "./pickups-create-modal.vue?vue&type=template&id=58a71660&"
import script from "./pickups-create-modal.vue?vue&type=script&lang=js&"
export * from "./pickups-create-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports